import userProjectDetailsReducer from "../slices/userProjectDetailsSlice";
import saveFormDataSlice from "../slices/saveFormDataSlice";
import appAdvisorResultsSlice from "../slices/appAdvisorResultsSlice";
import wizardModalSlice from "../slices/wizardModalSlice"
import unlinkProjectSlice from "../slices/unlinkProjectSlice"
import offerTypeSlice from "../slices/offerTypesListSlice"
import profileDataSlice from "../slices/profileDataSlice"
import liveOffersSlice from "../slices/liveOffersListSlice"

const rootReducer = {
  userProjectDetails: userProjectDetailsReducer,
  saveFormData: saveFormDataSlice,
  appAdvisorResults: appAdvisorResultsSlice,
  appAdvisorModal: wizardModalSlice,
  unlinkProject: unlinkProjectSlice,
  offerTypes: offerTypeSlice,
  profileData: profileDataSlice,
  liveOffers: liveOffersSlice
};

export default rootReducer;
